import { Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$error",
})<{ $error: boolean }>(({ $error, theme }) => ({
  width: 72,

  "& .MuiInputBase-root": {
    backgroundColor: $error
      ? alpha(theme.palette.error.main, 0.08)
      : "transparent",
  },
}));

export const Label = styled("label")(({ theme }) => ({
  ...theme.typography.caption,
  display: "block",
  textAlign: "center",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
}));
